import { render, staticRenderFns } from "./Subconta.vue?vue&type=template&id=ac8c3370&"
import script from "./Subconta.vue?vue&type=script&lang=ts&"
export * from "./Subconta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports